export class SupportStatusDto {

  public readonly available!: boolean;

  constructor(init?: Partial<SupportStatusDto>) {
    Object.assign(this, init);
  }
}
